import { przezmorzePublicApi } from "../../api/publicApi";

export interface B2bRequestBody {
  readonly name: string;
  readonly company: string;
  readonly nip: string;
  readonly email: string;
  readonly phone: string;
  readonly token: string;
}

export async function sendB2bRequest(request: B2bRequestBody, abortSignal?: AbortSignal) {
  const response = await przezmorzePublicApi.post<B2bRequestBody>("/public/b2b/requests", request, {
    signal: abortSignal,
  });
  return response.data;
}
